import React, { useEffect } from "react";
import { Field, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import { Select } from "components/common";
import useAWSRegions from "archive/hooks/useAWSRegions";
import { getS3ProviderCopy } from "archive/logic/s3CompatibleProviders";
const validateRegion = (endpointUri, requiredError) => (value) => (endpointUri == null ? void 0 : endpointUri.trim()) && !(value == null ? void 0 : value.trim()) ? requiredError : void 0;
const AWSRegionsFormGroup = ({ variant = "s3" }) => {
  const { t } = useTranslation("enterprise_archive");
  const { data: regions } = useAWSRegions();
  const {
    values: { settings },
    setFieldValue
  } = useFormikContext();
  const s3Settings = settings;
  const copy = getS3ProviderCopy(variant);
  useEffect(() => {
    if (!s3Settings.aws_region) {
      setFieldValue("settings.aws_region", "");
      return () => {
        setFieldValue("settings.aws_region", void 0);
      };
    }
    return () => void 0;
  }, [setFieldValue]);
  return /* @__PURE__ */ React.createElement(Field, { name: "settings.aws_region", validate: validateRegion(s3Settings.endpoint_uri, copy.regionRequiredError) }, ({ meta }) => /* @__PURE__ */ React.createElement(Input, { id: "default-aws-region-select", label: copy.regionLabel, error: meta.error, help: copy.regionHelp }, /* @__PURE__ */ React.createElement(
    Select,
    {
      id: "awsRegion",
      name: "AWSRegion",
      placeholder: t("aws_regions_form_group.automatic"),
      "aria-label": copy.regionAriaLabel,
      allowCreate: true,
      options: regions != null ? regions : [],
      onChange: (option) => {
        setFieldValue("settings.aws_region", option);
      },
      value: settings.aws_region
    }
  )));
};
export default AWSRegionsFormGroup;
